import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getCompanyTypes = async () => {
    try {
  return await get<ApiResponse<[]>>('/company/business-type-count').then((res)=> {
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){

}
};
